import React, { Component } from 'react'

 class Result extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}

export default Result
